<template lang='pug'>
  v-data-table( v-model="Cotizaciones.datos.items" :headers='itemHeadersRequered' hide-default-footer  :items='registro_de_requerimientos' item-key='id_requerimiento' show-select  )
    template( v-slot:item.descripcion="{item}" )
      v-tooltip(bottom='')
        template(v-slot:activator='{ on }')
          span(v-on='on') {{item.codigo}} {{item.descripcion}} {{item.presentacion}}
        span {{item.creado_el}}
    template( v-slot:item.actions='{item}')
      Aprobar_button( v-if='es_administrador' :id='item.id_requerimiento' tipo='requerimiento' :aprobado='item.aprobado')
      
</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
	data:()=>({
		itemHeadersRequered:[
      { text: 'Producto',    value: 'descripcion'},
      { text: 'Cant.',      value: 'cantidad' },
      { text: 'Creado por',      value: 'creado_por' },
      { text: '',      value: 'actions' },

    ],
  }),
  watch:{
    'db_activada'(){
      if(this.db_activada){
        this.$store.dispatch('Requerimientos/obtener_por_estado',{aprobado: this.es_administrador})     
      }
    }
  },
  created(){
    if(this.db_activada){
      this.$store.dispatch('Requerimientos/obtener_por_estado',{aprobado: this.es_administrador})           
    }
  },
  computed:{
    ...mapState({
     	Cotizaciones: state=>state.Cotizaciones,
      registro_de_requerimientos: state=>state.Requerimientos.record_por_estado,
      db_activada: state => state.Customers.db_activada
    })
  },
  components: {
    Aprobar_button: ()=>import('./aprobar_button')
  },
  props:{
    es_administrador: Boolean
  }
}
</script>
